import endoscopia from '../images/novedades/endoscopia.png'
import cmsiImage from '../images/novedades/radio-csi.png'

export const NewsData = [
	{
		title: '¿Cómo sacar turno para Endoscopía?',
		subtitle:
			'Para solicitar un turno de endoscopía, comunicate al 0800-666-6587 o por WhatsApp al 11 4493-2017, de lunes a viernes de 8:00 a 20:00 hs.\n\nPor el medio que elijas para contactarte, te brindarán las indicaciones y preparaciones previas necesarias para tu estudio.',
		image: endoscopia,
		contacts: [
			{ type: 'whatsapp', value: '+54 9 11 4493-2017', redirect: 'https://wa.me/5491144932017' },
			{ type: 'phone', value: '0800-666-6587' }
		]
	},
	{
		title: 'Conocé los estudios por imagen sin turno de nuestras clínicas y centros médicos',
		subtitle:
			'Podés acercarte al Centro Médico Santa Isabel (Av. Rivadavia 6044, Caballito) para realizar los siguientes estudios, sin turno previo, de lunes a viernes de 8:00 a 19:30hs.',
		image: cmsiImage,
		link: '/inicio/novedades'
	}
]
